import { registerElementI18nBundle } from '@ai-content-hub/content-core';
import type { ElementSchemaLanguageMap } from './useElementSchemaLocale';

/**
 * Register an element `schema.i18n` map into content-core defaults at module load.
 */
export function registerSchemaI18n(schemaI18n: ElementSchemaLanguageMap): void {
    registerElementI18nBundle({
        en: schemaI18n.en,
        vi: schemaI18n.vi,
    });
}
